import React from 'react'
import { useNavigate } from 'react-router-dom'


const JoinUs = props => {
  const navigate = useNavigate();


  const navigateSignIn = () => {
    navigate('/#signIn');
  };

   const navigateSignUp = () => {
    navigate('/#signUp');
  };

  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /* Auth user */
  let clientId = "4inkkk5uo5ef4foec6enqofo0v";
  let lastAuthUser = getCookie("CognitoIdentityServiceProvider."+ clientId +".LastAuthUser");
  let user = getCookie("CognitoIdentityServiceProvider."+ clientId +"."+ lastAuthUser +".userData");

  if (typeof user === "undefined" || user === "" || user === "undefined") {

    return (
      <>
        <div className="content_end mb15">
          <div className="button_container">
            <div className="join_button" onClick={navigateSignUp}>Liity</div>
            <div className="signin_link_wrapper">Oletko jo jäsen?<span className="sign_link" onClick={navigateSignIn}>Kirjaudu sisään</span></div>
          </div>
        </div>
      </>
    )
  }else{
    return (
       <></>
    )
  }
  /* End: Auth user */
}
export default JoinUs;